
import { CardSkeleton, CardSkeletonCategory, CarouselSkeletonContainer } from "../../components/CarouselSkeleton/CarouselSkeleton.styles";

export const TabsSkeleton = () => {

  return (
    <CarouselSkeletonContainer style={ { display:"flex", gap: "0.5rem", padding: "1rem 0rem" } }>
      <CarouselSkeletonContainer>
        { /* <TitleSkeleton></TitleSkeleton> */ }
        <div className="container">
          <CardSkeleton sx={ { height:"2.5rem", display:"flex", alignItems:"center", width:"8rem", padding:0, justifyContent:"center" } } >
            <CardSkeletonCategory sx={ { height:"1rem", marginBottom:0, width:"calc(100% - 3rem)" } } ></CardSkeletonCategory>
          </CardSkeleton>
          <CardSkeleton sx={ { height:"2.5rem", display:"flex", alignItems:"center", width:"8rem", padding:0, justifyContent:"center" } } >
            <CardSkeletonCategory sx={ { height:"1rem", marginBottom:0, width:"calc(100% - 3rem)" } } ></CardSkeletonCategory>
          </CardSkeleton>
          <CardSkeleton sx={ { height:"2.5rem", display:"flex", alignItems:"center", width:"8rem", padding:0, justifyContent:"center" } } >
            <CardSkeletonCategory sx={ { height:"1rem", marginBottom:0, width:"calc(100% - 3rem)" } } ></CardSkeletonCategory>
          </CardSkeleton>
        
        </div>
      </CarouselSkeletonContainer>
    </CarouselSkeletonContainer>  

  );};
